import { useSelector } from 'react-redux'
import { selectCommunityWatchlists } from '../selectors/watchList'
import { Watchlist_Type } from '../proto/generated/watchlist'

export const useAdminScreenerAccess = () => {
    const communityWatchlists = useSelector(selectCommunityWatchlists)
    return (shareId: string | undefined) => {
        // User-owned watchlists are not in the community catalog.
        if (!shareId) {
            return true
        }
        if (!communityWatchlists?.length) {
            // Catalog not loaded yet; don't block actions on personal watchlists.
            return true
        }
        const srcWatchlist = communityWatchlists.find((wl) => wl.shareId === shareId)
        if (!srcWatchlist) {
            return true
        }
        return srcWatchlist.type !== Watchlist_Type.SCREENER
    }
}
